import Player from "./pages/player/Player";
import PlayerCompact from "./pages/player/PlayerCompact";
import PlayerFixed from "./pages/player/PlayerFixed";
import PlayerV4 from "./pages/player/PlayerV4";
import { Route, Routes, BrowserRouter } from "react-router-dom";
import "./App.css";

function App() {
  return (
    <BrowserRouter basename={"/audio"}>
      <Routes>
        <Route index path="/" element={<Player />} />
        <Route path="/:port/:name" element={<Player />} />
        <Route path="/v2/" element={<PlayerCompact />} />
        <Route path="/v2/:port/:name" element={<PlayerCompact />} />
        <Route path="/v3/" element={<PlayerFixed />} />
        <Route path="/v3/:port/:name" element={<PlayerFixed />} />
        <Route path="/v4/" element={<PlayerV4 />} />
        <Route path="/v4/:port/:name" element={<PlayerV4 />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
